<template>
  <v-list dense>
    <template v-for="item in menu">
      <v-list-item :key="item.text" :to="item.to" link>
        <v-list-item-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            {{ item.text }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-group :value="false" key="tools" prepend-icon="mdi-open-in-new">
        <template v-slot:activator>
          <v-list-item-title>Outils</v-list-item-title>
        </template>

        <v-list-item link :href="getStripeUrl()" target="_blank">
          <v-list-item-title>Paiements (Stripe)</v-list-item-title>
          <v-list-item-icon>
            <v-icon>mdi-currency-usd</v-icon>
          </v-list-item-icon>
        </v-list-item>

        <v-list-item link :href="getClickyUrl()" target="_blank">
          <v-list-item-title>Visites (Clicky)</v-list-item-title>
          <v-list-item-icon>
            <v-icon>mdi-chart-line-variant</v-icon>
          </v-list-item-icon>
        </v-list-item>

        <v-list-item link :href="getDatadogHqUrl()" target="_blank">
          <v-list-item-title>Métriques (DatadogHQ)</v-list-item-title>
          <v-list-item-icon>
            <v-icon>mdi-chart-scatter-plot-hexbin</v-icon>
          </v-list-item-icon>
        </v-list-item>

        <v-list-item link :href="getMailgunUrl()" target="_blank">
          <v-list-item-title>Emails (Mailgun)</v-list-item-title>
          <v-list-item-icon>
            <v-icon>mdi-email</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list-group>
    </template>
  </v-list>
</template>

<script>
export default {
  name: 'AppNavigationAdmin',
  data () {
    return {
      menu: [
        { icon: 'mdi-account', text: 'Gestion des utilisateurs', to: '/admin/users' },
      ],
    }
  },
  methods: {
    getStripeUrl () {
      return 'https://dashboard.stripe.com/'
    },
    getDatadogHqUrl () {
      return 'https://datadoghq.eu/dashboard/lists'
    },
    getClickyUrl () {
      return 'https://clicky.com/stats/?site_id=101286529'
    },
    getMailgunUrl () {
      return 'https://app.eu.mailgun.com/app/dashboard'
    },
  }
}
</script>

<style scoped>

</style>